import { useState, useEffect, useRef } from 'react';
import { useInView } from 'framer-motion';

const metrics = [
  { value: 48, prefix: '< ', suffix: 'h', label: 'Tiempo de respuesta al diagnóstico' },
  { value: 3, prefix: 'Top ', suffix: '', label: 'Perfiles máximos por mandato' },
  { value: 100, prefix: '', suffix: '%', label: 'Mandatos bajo protocolo NDA' },
  { value: 0, prefix: '', suffix: '€', label: 'Coste si no hay conexión exitosa' },
];

function CountUp({ target, prefix, suffix, active }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!active) return;
    if (target === 0) { setCount(0); return; }
    let raf;
    const duration = 1600;
    const startTime = performance.now();
    const tick = (now) => {
      const progress = Math.min((now - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.round(eased * target));
      if (progress < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [active, target]);

  return (
    <span className="text-4xl md:text-5xl lg:text-6xl font-light tracking-tight text-white">
      {prefix}{count}{suffix}
    </span>
  );
}

export default function Stats() {
  const sectionRef = useRef(null);
  const inView = useInView(sectionRef, { once: true, margin: '-80px' });

  return (
    <section
      ref={sectionRef}
      data-testid="stats-section"
      className="bg-[#1B2A4A] py-24 md:py-32 relative overflow-hidden"
    >
      <div className="grain absolute inset-0" />
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-6">
          {metrics.map((m, i) => (
            <div
              key={i}
              data-testid={`stat-${i}`}
              className="text-center md:text-left"
            >
              <CountUp target={m.value} prefix={m.prefix} suffix={m.suffix} active={inView} />
              <p className="text-[#8A9BB1] text-sm mt-3 leading-relaxed">{m.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
